// src/services/tradingService.js - FIXED VERSION
// ✅ BUG FIX: getUserStockHolding no longer throws error

import { API_BASE_URL } from '../utils/constants';


const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/';
    }
    const error = await response.json();
    throw new Error(error.error || error.detail || 'Request failed');
  }
  return response.json();
};

export const tradingService = {
  // Get stock detail for trading
  async getStockDetail(symbol) {
    try {
      const response = await fetch(`${API_BASE_URL}/trading/stocks/${symbol}/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching stock detail:', error);
      throw error;
    }
  },

  // Create a trade order
  async createOrder(orderData) {
    try {
      const response = await fetch(`${API_BASE_URL}/trading/orders/create/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
        body: JSON.stringify(orderData),
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  // Get user's portfolio (uses stocks app endpoint)
  async getPortfolio() {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/holdings/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      throw error;
    }
  },

  // Get portfolio summary (wallet balance, available balance, etc.)
  async getPortfolioSummary() {
    try {
      const response = await fetch(`${API_BASE_URL}/stocks/portfolio/summary/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching portfolio summary:', error);
      throw error;
    }
  },

  // ✅ FIXED: Get user's holding for specific stock - NO LONGER THROWS ERROR
  async getUserStockHolding(symbol) {
    try {
      // First get all holdings
      const holdings = await this.getPortfolio();
      
      // Find the holding for the specific stock symbol
      const holding = holdings.find(h => h.stock.symbol === symbol);
      
      // ✅ FIX: Return null instead of throwing error
      if (!holding) {
        return null;  // User doesn't own this stock yet
      }
      
      return holding;
    } catch (error) {
      console.error('Error fetching stock holding:', error);
      // ✅ FIX: Return null on error instead of throwing
      return null;
    }
  },

  // Get user's orders with optional filters
  async getUserOrders(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.type) params.append('type', filters.type);
      
      const url = `${API_BASE_URL}/trading/orders/${params.toString() ? '?' + params.toString() : ''}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await handleResponse(response);
      
      // Ensure we return an array (handle both array and object with results)
      return Array.isArray(data) ? data : (data.results || []);
    } catch (error) {
      console.error('Error fetching user orders:', error);
      throw error;
    }
  },

  // Cancel a pending order
  async cancelOrder(orderId) {
    try {
      const response = await fetch(`${API_BASE_URL}/trading/orders/${orderId}/cancel/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error canceling order:', error);
      throw error;
    }
  },

  // Convert limit order to market order
  async convertToMarketOrder(orderId) {
    try {
      const response = await fetch(`${API_BASE_URL}/trading/orders/${orderId}/convert-to-market/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error converting order to market:', error);
      throw error;
    }
  },

  // Get transaction history with optional filters
  async getTransactions(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.stock_id) params.append('stock_id', filters.stock_id);
      
      const url = `${API_BASE_URL}/trading/transactions/${params.toString() ? '?' + params.toString() : ''}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await handleResponse(response);
      
      // Ensure we return an array (handle both array and object with results)
      return Array.isArray(data) ? data : (data.results || []);
    } catch (error) {
      console.error('Error fetching transactions:', error);
      throw error;
    }
  }
};